/** Backend: EBannerType */
export const EBannerType = {
  HomeHorizontal: 1,
  Static: 2,
} as const;

export type EBannerTypeValue = (typeof EBannerType)[keyof typeof EBannerType];

export const EBannerTypeDisplayMap: Record<number, string> = {
  0: '—',
  [EBannerType.HomeHorizontal]: 'CARROSSEL',
  [EBannerType.Static]: 'ESTÁTICO',
};

/** Backend: EItemLocation */
export const EItemLocation = {
  Home: 1,
  Scheduling: 2,
} as const;

export type EItemLocationValue = (typeof EItemLocation)[keyof typeof EItemLocation];

export const EItemLocationDisplayMap: Record<number, string> = {
  0: '—',
  [EItemLocation.Home]: 'Página Inicial',
  [EItemLocation.Scheduling]: 'Página de Categorias',
};

/** Labels para formulários (ex: selects) */
export const EItemLocationFormLabels: Record<number, string> = {
  [EItemLocation.Home]: 'Topo (Header)',
  [EItemLocation.Scheduling]: 'Página de Categorias',
};

export const EBannerTypeFormLabels: Record<number, string> = {
  [EBannerType.HomeHorizontal]: 'Carrossel (Slider)',
  [EBannerType.Static]: 'Estático',
};
